"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatUrl = void 0;
var formatUrl = function (data, assetBaseUrl) {
    var input = __assign({}, data);
    var keys = Object.keys(input).filter(function (key) {
        return typeof input[key] === 'string' &&
            /.*\.(png|jpg|jpeg|svg|gif|mp3|pdf)$/.test(input[key]);
    });
    keys.forEach(function (key) {
        input[key] = "".concat(assetBaseUrl, "/").concat(input[key]);
    });
    return input;
};
exports.formatUrl = formatUrl;
